import ChildCard from "@shared-layouts/ChildCard";
import EditIcon from "@src/assets/icons/EditIcon";

import { Skeleton } from "@mui/material";
import { StyledButton, EmptyStateContainer, LoadingWrapper } from "./style";

interface EmptyStateProps {
  onClick: () => void;
  loading: boolean;
  isMobile: boolean;
}

const EmptyState = ({ onClick, loading, isMobile }: EmptyStateProps) => {
  const renderLoading = () => {
    return (
      <LoadingWrapper>
        <Skeleton width="30%" />
        <Skeleton width="70%" />
        <br />
        <br />
        <Skeleton width="30%" />
        <Skeleton width="70%" />
      </LoadingWrapper>
    );
  };

  return (
    <ChildCard title="" hideDivider disableDividerStyle>
      <EmptyStateContainer>
        {loading ? (
          renderLoading()
        ) : (
          <>
            <p>There are no notes added</p>
            {!isMobile && (
              <StyledButton variant="contained" onClick={onClick}>
                Add Note <EditIcon />
              </StyledButton>
            )}
          </>
        )}
      </EmptyStateContainer>
    </ChildCard>
  );
};

export default EmptyState;
